// extracted by mini-css-extract-plugin
module.exports = {"progressBarWrap":"styles_progressBarWrap__kRFXr","dashboard":"styles_dashboard__sNjkO","innerCircle":"styles_innerCircle__mLSUu"};